// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyC0ecbGXGJbG2jnoF9aPKlP2OToFX9cOLg",
  authDomain: "loyapp-343d9.firebaseapp.com",
  projectId: "loyapp-343d9",
  storageBucket: "loyapp-343d9.appspot.com",
  messagingSenderId: "895403386155",
  appId: "1:895403386155:web:231764bddbce490382116e",
  measurementId: "G-BK0E96EXPN",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
